/**
 * The keyword search over sections marks each matched word of a snippet between two private-use
 * characters (questions' `search_endpoints.MATCH_START` / `MATCH_END`, SB-396). No regulation text
 * holds them, so the page can mark the words as text and never reads the snippet as HTML.
 */
export const MATCH_START = String.fromCharCode(0xe000);
export const MATCH_END = String.fromCharCode(0xe001);

export interface SnippetPart {
    text: string;
    match: boolean;
}

/** A snippet as runs of plain and matched text, markers removed, in order. */
export function snippetParts(snippet: string): SnippetPart[] {
    const parts: SnippetPart[] = [];
    let rest = snippet;
    while (rest) {
        const start = rest.indexOf(MATCH_START);
        if (start < 0) {
            parts.push({text: rest, match: false});
            break;
        }
        if (start > 0) parts.push({text: rest.slice(0, start), match: false});
        const end = rest.indexOf(MATCH_END, start + 1);
        if (end < 0) {
            // An unclosed marker: what follows it is the match, so nothing is dropped.
            parts.push({text: rest.slice(start + 1), match: true});
            break;
        }
        parts.push({text: rest.slice(start + 1, end), match: true});
        rest = rest.slice(end + 1);
    }
    return parts.filter((part) => part.text);
}
